import styled from 'styled-components';
import {alignCenter, dFlex, dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {ellipsisLines} from '../../../../globalVariables/GlobalVariables';

export const body = styled.div`
    ${dFlexColumn};
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    gap: var(--space-lg);
    padding: 0 var(--space-lg) var(--space-md);
`;

export const infoBar = styled.div`
    ${dFlex};
    ${alignCenter};
    flex: none;
    gap: var(--space-sm);
    padding: var(--space-sm);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-sm);
`;

export const arrow = styled.span`
    ${dFlex};
    flex: none;
    color: var(--color-text-default);
    /* The arrow points from the series type to the explanation, along the reading direction */
    [dir='ltr'] & {
        transform: scaleX(-1);
    }
`;

export const infoText = styled.span`
    flex: 1 1 0;
    min-width: 0;
    font-size: var(--font-size-caption);
    line-height: 1.4;
    text-align: start;
`;

/* "About the series" — rich text the producer entered when creating the series */
export const description = styled.div`
    flex: none;
    font-size: var(--font-size-body-small);
    line-height: 1.55;
    text-align: start;
    white-space: pre-line;

    h3 {
        font-size: var(--font-size-body-small);
        font-weight: var(--font-weight-bold);
        line-height: 1.4;
        margin-bottom: var(--space-xs);
    }

    p {
        margin-bottom: var(--space-md);

        &:last-child {
            margin-bottom: 0;
        }
    }

    ul {
        padding-inline-start: var(--space-lg);
    }

    li {
        margin-bottom: var(--space-xs);
    }
`;

export const events = styled.div`
    ${dFlexColumn};
    flex: none;
    gap: var(--space-md);
`;

export const eventsTitle = styled.h3`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.4;
    text-align: start;
`;

export const eventsSubtitle = styled.small`
    display: block;
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
`;

export const eventRow = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: var(--space-md);
    padding: var(--space-md);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md);
    background: var(--color-bg-base-alt);
`;

export const eventText = styled.div`
    ${dFlexColumn};
    flex: 1 1 0;
    min-width: 0;
    gap: var(--space-xs);
    text-align: start;
`;

export const eventName = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.25;
    word-break: break-word;
    ${ellipsisLines(2)}
`;

export const eventMeta = styled.span`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    line-height: 1.4;
    word-break: break-word;
`;

/* An event that cannot be redeemed — not open for purchase / already passed */
export const eventBadge = styled.span`
    flex: none;
    padding: var(--space-xs) var(--space-sm);
    background: transparent;
    color: var(--color-state-error-main);
    border: 1px solid var(--color-state-error-main);
    border-radius: var(--border-radius-border-radius-full);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    line-height: 1.3;
    white-space: nowrap;
`;
